<div class="wrap">
  <button class="button" (click)="clicked.emit()">{{ buttonLabel }}</button>
</div>
